"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetAtpClusterId = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
/**
 * Wrapper hook for retrieving ATP Cluster ID for authenticated and anonymous customers.
 * Provides loading and errors states.
 * Can be enabled from the outside to prevent fetching data.
 */
const useGetAtpClusterId = ({
  customerId,
  tenant,
  enabled = true
}) => {
  const {
    data,
    error
  } = (0, _staticApiClientReact.useGetTenantAtpClusters)(tenant, {
    customerId
  }, {
    swr: {
      enabled,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  });
  return (0, _react.useMemo)(() => ({
    atpClusterId: data?.collection[0]?.atpClusterId,
    error,
    loading: enabled && data === undefined && error === undefined
  }), [data, error, enabled]);
};
exports.useGetAtpClusterId = useGetAtpClusterId;
